// extracted by mini-css-extract-plugin
module.exports = {"redesignedFont":"styles-module-redesignedFont--ILi_A","highlightedTextColor":"styles-module-highlightedTextColor--mNe74"};